import _, { includes } from "lodash";
import i18n from "../i18n";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  RECIPE_INITIALIZATION,
  RECIPE_ADD_ITEM,
  RECIPE_EDIT_SELECTED,
  RECIPE_SAVE_ITEM,
  RECIPE_DELETE,
  RESET_ID,
  RECIPE_SAVE,
  RECIPE_CLEAR,
  RECIPE_CREATE_CUISINE,
  RECIPE_CREATE_MEASUREMENT,
  GET_RECIPE,
  SEARCH_INGREDIENTS,
  SEARCH_RECIPES,
  ON_CHANGE_INGREDIENTFORM,
  ON_CHANGE_MYRECIPENTFORM,
  INGREDIENT_OPTION_SELECTED,
  INGREDIENT_KIT_SELECTED,
  INGREDIENT_KIT_ADDED,
  INGREDIENT_KIT_UPDATED,
  FOOD_UNITS,
  RECIPE_CATEGORY_SELECTED,
  ACTIVITY_UNITS,
  SYMPTOM_UNITS_NEW,
  DRUG_UNITS,
  PCP_UNITS,
  SUP_UNITS,
  LOC_UNITS,
  RECIPE_TO_BODYMAP,
  RECIPE_FROM_BODYMAP,
  SELECTED_CATEGORY,
  IS_UNSAVED,
  REPLACE_OR_ADD_RECIPE,
  // RECIPE_UPDATE_DUPLICATE_ITEM,
  RECIPE_BARCODE_READ,
  RECIPE_BARCODE_READ_IMG,
  UPDATE_RECIPE_NAME,
  PARTIAL_RESULT_FOUND,
  GET_RECIPE_DETAIL,
  ON_CHANGE_ALERT_STATUS,
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  SET_HHMM_MODE,
  RESET_CONTRIBUTE_ALERT_STATE,
  COMMIT_TYPED_RECIPE_NAME,
} from "../actions/constant";
import {
  getScaleList,
  handleUnitDropdown,
  detectIngredientChanged,
  convertHHMMForBackend,
  convertHHMMForDisplay,
} from "../lib/helper";

const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  actionResponse: null,
  recipe: null,
  measurementOptions: [],
  scaleOptions: [],
  cuisineOptions: [],
  ingredientList: [],
  kitData: [],
  ingredientForm: {},
  recipeOptions: [],
  recipeForm: {},
  recipeFormValue: {},
  isEditing: false,
  recipeTotalOptions: [],
  ingredientOptions: [],
  selectedIndex: -1,
  disabled: {
    recipe: true,
    cuisine: true,
    size: true,
    ingredientName: true,
    ingredientbrand: true,
    ingredientcomment: true,
    ingredientunit: true,
    ingredientsize: true,
    addBtn: true,
    saveBtn: true,
    clearBtn: true,
    category: false,
  },
  // previouscustomRecipe: false,
  classNames: {
    recipeName: "blinking",
  },
  deleteMode: false,
  updateMode: false,
  amountReseter: false,
  amounNewValue: null,
  getRecipe: false,
  counterState: 0,
  firstChange: false,
  sameIngredient: false,
  saveSuccess: false,
  itemInVer: false,
  cancelMode: false,
  replaceAlert: false,
  newList: [],
  previousRecipe: {
    servingSize: 0,
    comment: "",
  },
  comment: "",
  getRecipe: false,
  duplicateItem: false,
  updateRecipe: false,
  UpdateHistoricalData: false,
  addedItem: false,
  duplicateList: [],
  customRecipe: false,
  RefDbRecipe: false,
  alreadyUsedRecipeName: false,
  alreadyUsedRecipeNameInContent: false,
  deletedRecipeName: [],
  incompatibleName: false,
  alreadyExistRecipeName: false,
  incompatibleIngredient: false,
  incompatibleHiddenIngredient: false,
  excessiveNestedRecipe: false,
  hiddenIngredientList: [],
  partialResult: [],
  customItem: false,
  duplicateEntry: false,
  ingredientsAdded: false,
  replaceItemsAdded: false,
  exactExistRecipeId: "",
  updateRecipeData: false,
  itemChanged: false,
  isSuggestLoading: false,
  lastSuggestLoadedAt: 0,
  hhmmMode: false,
  recipeNameBaseline: "",
};

// Resolve final display name
const getRecipeName = (rec = {}) =>
  rec.recipe_full || rec.fullname || rec.name || rec.recipe || "";

// Map "items" payload (non-food) to your ingredientList shape
const mapItemsToIngredients = (items = []) =>
  items.map((it) => ({
    recipe: it.fullname,
    recipe_full: it.fullname,
    recipes: it.name,
    size: it.value,
    unitid: it.unitid || (Array.isArray(it.unit) ? it.unit[0] : undefined),
    unitList: it.unit,
    unit: it.unit,
    _id: it._id,
    ingredients_text: it.ingredients_text,
    upc: it.upc || null,
  }));

// Normalize payload ingredients list to the shape state expects
const normalizeIncomingList = (actionRecipe) => {
  if (Array.isArray(actionRecipe && actionRecipe.items)) return mapItemsToIngredients(actionRecipe.items);
  if (Array.isArray(actionRecipe && actionRecipe.ingredients)) return actionRecipe.ingredients; // already food-shape
  return [];
};

// Clean comment (append, trim, remove "undefined")
const joinComments = (prev = "", next = "") => {
  let c = `${prev}\n${next}`.replace(/undefined/g, "").replace(/^\s+/, "");
  return c;
};

// Classify selection by ID + presence of ingredient/item array
const classifySelection = (rec = {}) => {
  const idStr =
    rec && rec._id != null ? String(rec._id).trim() : "";

  const hasList =
    (Array.isArray(rec.ingredients) && rec.ingredients.length > 0) ||
    (Array.isArray(rec.items) && rec.items.length > 0);

  // No ID → new recipe or custom item
  if (!idStr) {
    return {
      RefDbRecipe: false,
      customRecipe: false,
      customItem: !hasList,
    };
  }

  // ID present & starts with "6"
  if (idStr.startsWith("6")) {
    return {
      RefDbRecipe: false,
      customRecipe: hasList,   // list → custom recipe
      customItem: !hasList,    // no list → custom item
    };
  }

  // ID present & NOT starting with "6" → RefDB recipe
  return {
    RefDbRecipe: true,
    customRecipe: false,
    customItem: false,
  };
};

// Recipe reducer
function reducer(state = initialState, action) {
  function isZeroEquivalent(scale) {
    if (!scale || typeof scale !== "string") return true; // covers "", null, undefined

    const trimmed = scale.trim();

    // Zero equivalent HH:MM format
    const isZeroTimeFormat = /^0{1,2};0{1,2}$/.test(trimmed);
    if (isZeroTimeFormat) return true;

    // Matches 0, 0., 0.0, 000, 000.000, 0/2 etc. but NOT 0 0, 0/ or 0&1
    // const zeroEquivalentPattern = /^(?:[0.]*0+(?:\s*\/\s*[1-9]\d*)?|(?:[0.]*0+\s*(?:[& ]+\s*0+)+\s*\/\s*[1-9]\d*))$/;
    const zeroEquivalentPattern = /^(?:0*\.?0*\.?|0*(?:[& ]+0+)*\s*\/\s*[1-9]\d*)$/
    return zeroEquivalentPattern.test(trimmed);
  }

  function buttonsChecker() {
    // ---------- tiny helpers ----------
    const cat = state.recipeForm && state.recipeForm.category;
    const isRecipe = cat === "999";
    const isSymptom = cat === "01";
    const hasValidCategory = !!cat && cat !== "null";

    const ingredientForm = state.ingredientForm || {};
    const recipeForm = state.recipeForm || {};
    const ingredientSelected = state.ingredientSelected || {};
    const selected = state.selectedIndex >= 0;
    const isKitItem = Array.isArray(state.kitData) && state.kitData.length > 0;

    const str = (v) => (v == null ? "" : String(v));
    const isFilled = (v) => !!str(v).trim();
    const notNullStr = (v) => isFilled(v) && str(v) !== "null";

    const ingredientNameFilled = isFilled(ingredientForm.recipe_full);
    const unitFilled = notNullStr(ingredientForm.unitid);
    const sizeRaw = ingredientForm.size;
    const sizeBasicFilled = notNullStr(sizeRaw);

    // Size rule for enabling Add/Update:
    // - For category "01": 0 / zero-equivalent counts as filled
    // - For other categories: zero-equivalent counts as NOT filled
    const sizeFilledForAdd = isSymptom
      ? (sizeBasicFilled || !isZeroEquivalent(str(sizeRaw)))
      : (sizeBasicFilled && !isZeroEquivalent(str(sizeRaw)));

    // Kit vs non-kit add eligibility
    const ingredientAddEligible = isKitItem
      ? ingredientNameFilled // kit: only name matters
      : (ingredientNameFilled && unitFilled && sizeFilledForAdd); // non-kit: name+unit+size

    // When an item is selected, Add is allowed only if changes were made AND fields are valid.
    // Otherwise, if no item is selected, Add follows the usual eligibility.
    const itemChanged = !!state.itemChanged;
    const addBtn = selected ? (itemChanged && ingredientAddEligible) : ingredientAddEligible;

    // Update/Cancel visibility is only relevant when an item is selected
    const updateMode = selected ? !!(itemChanged && ingredientAddEligible) : false;
    const cancelMode = selected
      ? (!itemChanged || (itemChanged && !ingredientAddEligible))
      : false;

    // ---------- Field enable/disable ----------
    // Recipe/regimen name enablement: only when a valid category is selected
    state.disabled.recipe = !hasValidCategory;

    // Serving size field (top-level) only for Recipe category
    state.disabled.size = !isRecipe;

    // Remove blinking regardless
    state.classNames.recipeName = "";

    // When recipe/regimen name is present, enable these; else disable
    const recipeNameFilled = isFilled(recipeForm.recipe);
    state.disabled.cuisine = !recipeNameFilled;
    state.disabled.ingredientcomment = !recipeNameFilled;
    state.disabled.ingredientName = !recipeNameFilled;
    state.disabled.scale = !recipeNameFilled;
    state.disabled.ingredientbrand = !recipeNameFilled;

    // Ingredient-level symbol & size:
    // - disabled for kit items
    // - enabled when ingredient name is filled (and we’re not kit)
    state.disabled.ingredientunit = isKitItem || !ingredientNameFilled || state.disabled.ingredientName;
    state.disabled.ingredientsize   = isKitItem || !ingredientNameFilled || state.disabled.ingredientName;

    // ---------- Clear button ----------
    state.disabled.clearBtn = !(
      isFilled(recipeForm.recipe) ||
      isFilled(recipeForm.cuisine) ||
      isFilled(recipeForm.size) ||
      isFilled(ingredientForm.recipe) ||
      isFilled(ingredientForm.unitid) ||
      isFilled(ingredientForm.size) ||
      isFilled(ingredientForm.comment) ||
      isFilled(ingredientForm.brand) ||
      (Array.isArray(state.ingredientList) && state.ingredientList.length > 0) ||
      (state.category && state.category !== "null")
    );

    // ---------- Save button ----------
    const recipeNameOk = isFilled(recipeForm.recipe);
    const minIngredientsOk = Array.isArray(state.ingredientList) && state.ingredientList.length >= 2;
    const servingOk = isRecipe ? isFilled(recipeForm.size) : true;

    // Define "changes made" for the Save button (recipe/regimen)
    // Prefer an explicit flag if you maintain one elsewhere; otherwise fall back to a light diff.
    const listOrdered = orderIngredientList(state.ingredientList || []);
    const newList = _.orderBy(listOrdered, "recipe_full", "asc");
    const baseList = _.orderBy(state.duplicateList || [], "recipe_full", "asc");
    const baseForm = state.recipeFormValue || {};

    const formChanged =
      str(recipeForm.recipe) !== str(baseForm.recipe) ||
      str(recipeForm.comment) !== str(baseForm.comment) ||
      (isRecipe && str(recipeForm.size) !== str(baseForm.size)) ||
      !_.isEqual(newList, baseList) ||
      !!state.ingredientsAdded;
      
    const requiredFilled = recipeNameOk && minIngredientsOk && servingOk;
    // - If customRecipe: enable Save only when requiredFilled && formChanged
    // - Otherwise (RefDB or new recipe): enable Save when requiredFilled
    const saveBtn = !!state.customRecipe ? !(requiredFilled && formChanged) : !(requiredFilled);

    // LocalStorage flags (unchanged behavior)
    if (requiredFilled && formChanged) {
      if (isRecipe) {
        localStorage.setItem("logoutWithoutSaveRecipe", "Yes");
      } else {
        localStorage.setItem("logoutWithoutSaveRegimen", "Yes");
      }
    } else {
      if (isRecipe) {
        localStorage.removeItem("logoutWithoutSaveRecipe");
      } else {
        localStorage.removeItem("logoutWithoutSaveRegimen");
      }
    }

    // Flag for "Update Historical Data Prompt"
    if (isRecipe) {
      const listChanged = !_.isEqual(newList, baseList);
      const sizeChanged = str(recipeForm.size) !== str(baseForm.size);
      state.UpdateHistoricalData = state.customRecipe && (listChanged || sizeChanged);
    } else {
      state.UpdateHistoricalData = false;
    }

    // Disable Category only for Existing Custom Recipe/Regimen
    state.disabled.category = state.customRecipe;

    // ---------- Extra rules preserved from original ----------
    // Final button states
    savedData(saveBtn, cat);          // keep your side-effect
    state.disabled.saveBtn = saveBtn; // save is disabled when true
    state.disabled.addBtn = !addBtn;  // add is disabled when true

    // Update/Cancel modes (deleteMode removed)
    state.updateMode = updateMode;
    state.cancelMode = cancelMode;
    state.deleteMode = false;

    state.counterState = (state.counterState || 0) + 1;
  }

  function savedData(flag, category = "") {
    if (!flag) {
      let vAlertMessages = {
        title:
          state.recipeForm.category && state.recipeForm.category == "999"
            ? i18n.t("recipe.UNSAVED_RECIPE_LEAVE_PAGE_TITLE")
            : i18n.t("recipe.UNSAVED_REGIMEN_LEAVE_PAGE_TITLE"),
        text:
          state.recipeForm.category && state.recipeForm.category == "999"
            ? i18n.t("recipe.UNSAVED_RECIPE_LEAVE_PAGE_TEXT_2")
            : i18n.t("recipe.UNSAVED_REGIMEN_LEAVE_PAGE_TEXT_2"),
      };
      localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
      IS_UNSAVED("yes");
      if (category) {
        if (category === "999") {
          localStorage.setItem("logoutWithoutSaveRecipe", "Yes");
        } else {
          localStorage.setItem("logoutWithoutSaveRegimen", "Yes");
        }
      }
    } else {
      localStorage.removeItem("logoutWithoutSaveRecipe");
      localStorage.removeItem("logoutWithoutSaveRegimen");
      IS_UNSAVED("no");
    }
  }

  function orderIngredientList(ingredientList) {
    let arr = [];
    ingredientList.map((ingredient) => {
      let list = {
        // _id: ingredient._id,
        recipe_full: ingredient.recipe_full,
        size: ingredient.size || "0",
        unitid: ingredient.unitid,
      };
      arr.push(list);
    });
    return arr;
  }

  function foodunits() {
    let funits = [];
    funits = FOOD_UNITS().map((e) => {
      return {
        label: e.unit,
        value: e._id,
      };
    });
    return funits;
  }
  let ingredientList = [];
  let selectedIndex = -1;

  function getCategoryUnits(category) {
    try {
      switch (category) {
        case "03": { // Activity
          const EXCLUDE = new Set(["103", "104"]);
          const src = ACTIVITY_UNITS() || [];
          return src
            .filter(u => !EXCLUDE.has(String(u._id)))                 // exclude 103 & 104
            .map(u => ({ value: String(u._id), label: String(u.unit || "") }));
        }
        case "01": // Symptom
          return [{ value: "142", label: i18n.t("symptoms.ITEM_UNIT_TEXT") }];
        case "02":
        case "999": // Food / Recipe
          return foodunits() || [];
        case "04":
          return (PCP_UNITS() || []).map(u => ({ value: String(u._id), label: u.unit }));
        case "05":
          return (DRUG_UNITS() || []).map(u => ({ value: String(u._id), label: u.unit }));
        case "06":
          return (SUP_UNITS() || []).map(u => ({ value: String(u._id), label: u.unit }));
        case "07":
          return (LOC_UNITS() || []).map(u => ({ value: String(u._id), label: u.unit }));
        default:
          return [];
      }
    } catch (e) {
      return [];
    }
  }

  switch (action.type) {
    case getStarted(RECIPE_INITIALIZATION):
      let editId = action.payload[0];
      state.isEditing = editId ? true : false;
      state.addedItem = false;
      state.customRecipe = false;
      state.RefDbRecipe = false;
      state.customItem = false;
      state.exactExistRecipeId = "";
      state.alreadyUsedRecipeName = false;
      state.alreadyUsedRecipeNameInContent = false,
      state.deletedRecipeName = [],
      state.incompatibleName = false;
      state.alreadyExistRecipeName = false;
      state.incompatibleIngredient = false;
      state.incompatibleHiddenIngredient = false;
      state.excessiveNestedRecipe = false;
      state.duplicateEntry = false;
      state.replaceItemsAdded = false;
      state.updateRecipeData = false;
      state.ingredientsAdded = false;
      // state.customRecipeHasRefDbItem = false;
      state.recipeFormValue = {};
      state.hiddenIngredientList = [];
      state.UpdateHistoricalData = false;
    //  return { ...state };
    case getStarted(RECIPE_SAVE):
      IS_UNSAVED("no");
      state.incompatibleHiddenIngredient = false;
      state.excessiveNestedRecipe = false;
      state.hiddenIngredientList = [];
      state.incompatibleName = false;
      state.deletedRecipeName = [];
      return {
        ...state,
        isLoading: true,
        alreadyUsedRecipeName: false,
        alreadyUsedRecipeNameInContent: false,
        deletedRecipeName: [],
        alreadyExistRecipeName: false,
        incompatibleIngredient: false,
      };
    case getStarted(RECIPE_CREATE_CUISINE):
    case getStarted(RECIPE_CREATE_MEASUREMENT):
      return { ...state, isLoading: true };
    case getSucceeded(RECIPE_INITIALIZATION):
      let measurements = [];
      let cuisines = [];
      let categories = action.payload[0];
      let EditId = action.payload[1];
      // let EditId = action.payload._id;
      let measurementOptions = [];
      let scaleOptions = [];
      let cuisineOptions = [];
      // for (const cuisine of cuisines) {
      //   cuisineOptions.push({ value: cuisine._id, label: cuisine.cuisine });
      // }

      // cuisineOptions.push({ value: "Other", label: "Other" });
      state.isEditing = EditId ? true : false;

      buttonsChecker();
      return {
        ...state,
        saveSuccess: false,
        status: statusEnum.SUCCESS,
        measurementOptions,
        cuisineOptions,
        categories,
        cancelMode: false,
        updateRecipe: false,
      };
    case RECIPE_CATEGORY_SELECTED:
      if (action.value == "null") {
        state.disabled.recipe = true;
      } else {
        state.disabled.recipe = false;
      }
      let category = action.value;
      let units = [];
      if (category == "03") {
        let act_units = ACTIVITY_UNITS();
        units = act_units.map((item) => {
          return { value: item._id, label: item.unit };
        });
      } else if (category == "01") {
        units = [{ value: "142", label: i18n.t("symptoms.ITEM_UNIT_TEXT") }];
      } else if (category == "02" || category == "999") {
        units = foodunits();
      } else if (category == "04") {
        let act_units = PCP_UNITS();
        units = act_units.map((item) => {
          return { value: item._id, label: item.unit };
        });
      } else if (category == "05") {
        let act_units = DRUG_UNITS();
        units = act_units.map((item) => {
          return { value: item._id, label: item.unit };
        });
      } else if (category == "06") {
        let act_units = SUP_UNITS();
        units = act_units.map((item) => {
          return { value: item._id, label: item.unit };
        });
      } else if (category == "07") {
        let act_units = LOC_UNITS();
        units = act_units.map((item) => {
          return { value: item._id, label: item.unit };
        });
      }
      measurementOptions = units;
      state.ingredientList = [];
      state.ingredientForm = {};
      state.outOfRange = false;
      state.recipeForm.recipe = "";
      state.recipeForm.comment = "";
      state.recipeForm.size = "";
      state.recipeForm._id = "";
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.scaleOptions = [];
      state.category = category;
      state.recipeForm = { ...state.recipeForm, category };
      state.ingredientSelected = {};
      state.firstChange = false;
      state.updateMode = false;
      state.cancelMode = false;
      state.deleteMode = false;
      state.selectedIndex = -1;
      state.getRecipe = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      return {
        ...state,
        isLoading: false,
        category,
        measurementOptions,
        recipeForm: state.recipeForm,
      };

    case getSucceeded(RECIPE_CREATE_CUISINE):
      let cuisineName = action.payload.cuisine;
      let cuisineID = action.payload._id;

      cuisines = [...state.cuisineOptions];
      cuisines.splice(0, 0, { value: cuisineID, label: cuisineName });
      return {
        ...state,
        cuisineOptions: cuisines,
        recipeForm: { ...state.recipeForm, cuisine: cuisineID },
      };
    case getSucceeded(RECIPE_CREATE_MEASUREMENT):
      let measurementName = action.payload.name;
      measurements = [...state.measurementOptions];
      measurements.splice(0, 0, {
        value: measurementName,
        label: measurementName,
      });
      return {
        ...state,
        measurementOptions: measurements,
        ingredientForm: {
          ...state.ingredientForm,
          measurement: measurementName,
        },
      };
    case RECIPE_EDIT_SELECTED:
      state.ingredientFormPrevious = {}
      selectedIndex = action.index;
      state.updateRecipe = false;
      state.replaceItemsAdded = false;
      ingredientList = [...state.ingredientList];
      let ingredientSelected = { ...ingredientList[selectedIndex] };

      for (const ingredient of ingredientList) {
        ingredient.isSelected = false;
        state.cancelMode = false;
      }
      ingredientList[selectedIndex].isSelected = true;
      state.cancelMode = true;

      if (selectedIndex == state.selectedIndex) {
        // === Deselect path ===
        state.cancelMode = false;
        ingredientSelected = {};
        ingredientList[selectedIndex].isSelected = false;
        selectedIndex = -1;

        // reset field
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";

        // 🕒 If we were in HH:MM mode, exit it on deselect
        if (state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter;
        }

      } else {
        // === Select path ===
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = ingredientSelected.size;
      }

      state.ingredientList = ingredientList;
      state.selectedIndex = selectedIndex;

      state.ingredientForm = { ...ingredientSelected };
      state.ingredientSelected = ingredientSelected;

      state.ingredientForm = {
        ...state.ingredientForm,
        recipe: state.ingredientForm.recipe,
        recipe_full: state.ingredientForm.recipe_full || state.ingredientForm.fullname,
        fullname: state.ingredientForm.fullname,
        size: state.ingredientForm.size
          ? state.ingredientForm.size
          : state.ingredientForm.value,
        unitid: ingredientSelected.unitid
          ? ingredientSelected.unitid
          : ingredientSelected.unit && ingredientSelected.unit.toString(),
      };

      // unit and scale
      // Derive a normalized unit ID list from the selected row (prefer persisted unitList)
      const toArray = (x) => (Array.isArray(x) ? x : (x != null && x !== "" ? [x] : []));
      const toStr   = (v) => String(v);

      const rawList =
        ingredientSelected.unitList ||
        ingredientSelected.units ||
        ingredientSelected.unit ||
        ingredientSelected.unitsid ||
        [];

      const unitListIds = toArray(rawList).map(toStr); // always string[]

      // Ensure form carries normalized units for future cycles
      state.ingredientForm.unitList = unitListIds;
      state.ingredientForm.units    = unitListIds;

      // Keep previously persisted selection if present; else spec autoselect
      if (ingredientSelected.unitid) {
        state.ingredientForm.unitid = toStr(ingredientSelected.unitid);
      } else {
        state.ingredientForm.unitid = (unitListIds.length === 1 && unitListIds[0] !== "910") ? unitListIds[0] : "";
      }

      // Build dropdown strictly from the unit IDs (helper handles blank / 910 / explicit)
      state.measurementOptions = handleUnitDropdown(state.recipeForm.category, { unitList: unitListIds });

      // Symptom scale options derived from the available unit IDs
      state.scaleOptions = (state.recipeForm.category === "01")
        ? getScaleList(unitListIds)
        : [];

      // 🕒 Auto-toggle HH:MM mode based on the selected item's unit (only on SELECT path)
      // If user deselected above, selectedIndex == -1 and we already flipped hhmmMode off.
      if (state.selectedIndex !== -1) {
        const isHHMMUnit =
          state.ingredientForm.unitid === "445" || state.ingredientForm.unitid === 445;
        if (isHHMMUnit && !state.hhmmMode) {
          state.hhmmMode = true;
          state.amountReseter = !state.amountReseter;
        } else if (!isHHMMUnit && state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter;
        }
      }

      state.kitData = [];
      if (action.clearField) {
        state.isItemSelected = true;
      }
      state.itemChanged = false;
      state.outOfRange = false;
      buttonsChecker();
      return {
        ...state
      };
    case getSucceeded(RECIPE_SAVE):
      state.disabled = {
        addBtn: true,
        saveBtn: true,
        clearBtn: true,
      };
      state.classNames = {
        recipeName: "blinking",
      };
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.exactExistRecipeId = "";
      state.UpdateHistoricalData = false;
      localStorage.removeItem("logoutWithoutSaveRegimen");
      localStorage.removeItem("logoutWithoutSaveRecipe");

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      IS_UNSAVED("no");
      localStorage.removeItem("unsavedAlertData");
      return {
        ...state,
        isLoading: false,
        saveSuccess: true,
        isEditing: false,
        selectedIndex: -1,
        ingredientList: [],
        ingredientForm: {},
        updateRecipe: false,
        ingredientsAdded: false,
        status: statusEnum.SUCCESS,
      };
    case getFailed(RECIPE_INITIALIZATION):
    case getFailed(RECIPE_CREATE_CUISINE):

    case getFailed(RECIPE_SAVE):
      savedData(state.disabled.saveBtn, state.recipeForm.category);
      const { message, meta } = action.error;
      console.log("message", message)

      if (message === "name already exists") {
        state.alreadyUsedRecipeNameInContent = false;
        state.alreadyUsedRecipeName = false;
        state.deletedRecipeName = [];

        const normalizeName = (val) =>
          String(val || "")
            .replace(/\(c(r|g)?\)$/i, "")   // remove (C), (CR), (CG) at end
            .replace(/\s+/g, " ")       // collapse spaces
            .trim()
            .toLowerCase();

            // .replace(/\s*\((c(r|g)?|r)\)(?:\s*-\s*shared(?:\s+\d+)?)?$/i, "")

        const recipeName = normalizeName(state.recipeForm.recipe);

        const metaName =
          Array.isArray(meta) && meta.length > 0
            ? normalizeName(meta[0])
            : "";

        if (recipeName !== metaName) {
          state.alreadyUsedRecipeNameInContent = true;
          state.deletedRecipeName = Array.isArray(meta)
            ? meta.map(m => ({ value: m }))
            : [];
        } else {
          state.alreadyUsedRecipeName = true;
        }
      } else if (message === "exact name exists") {
        state.alreadyExistRecipeName = true;
        state.exactExistRecipeId = meta[0];
      } else if (message === "incompatible_ingredient") {
        state.incompatibleIngredient = true;
      } else if (message === "incompatible_hidden_ingredient") {
        state.incompatibleHiddenIngredient = true;
        state.hiddenIngredientList = meta;
      } else if (message === "excessive_nested_recipes") {
        state.excessiveNestedRecipe = true;
        state.hiddenIngredientList = meta;
      } else if (message === "identical") {
        state.incompatibleName = true;
      }

      return { ...state, actionResponse: action.payload, isLoading: false };
    case getEnded(RECIPE_INITIALIZATION):
    case getEnded(RECIPE_SAVE):
      return { ...state, isLoading: false, exactExistRecipeId: "" };
    case getEnded(RECIPE_CREATE_CUISINE):
    case getEnded(RECIPE_CREATE_MEASUREMENT):
      return { ...state, isLoading: false };

    case UPDATE_RECIPE_NAME: {
      const recipe = action.fullName || action.recipeName || "";
      const nextId = action.id || "";

      // Derive flags purely from id + absence of list (this is a name-only selection)
      const { RefDbRecipe, customRecipe, customItem } = classifySelection({ _id: nextId });

      state = {
        ...state,
        recipeForm: {
          ...state.recipeForm,
          recipe,
          _id: nextId,           // <-- ensure form holds the accepted id
        },
        // Baselines update on accepted selection (no prompt in this path)
        recipeNameBaseline: recipe,
        recipeIdBaseline: nextId,
        recipeHasIngredientBaseline: false,

        // Adopt flags from id classification; UI toggles stay in buttonsChecker
        RefDbRecipe,
        customRecipe,
        customItem,
      };

      buttonsChecker();  // pass the computed state
      return{ ...state, isLoading: false };
    }

    case GET_RECIPE_DETAIL: {
      state.isEditing = true;

      const data = action.payload;
      defaultData = localStorage.getItem("contDefault");
      defaultVal = JSON.parse(defaultData);

      if (data) {
        state.selectedIndex = data.selectedIndex;
        state.ingredientList = [...data.ingredientList];
        state.duplicateList = [...data.duplicateList];
        state.recipeFormValue = data.recipeFormValue;
        state.recipeForm = data.recipeForm;
        state.ingredientSelected = data.ingredientSelected;
        state.disabled.recipe = false;
        state.customRecipe = data.customRecipe;
        state.getRecipe = data.getRecipe;
        state.RefDbRecipe = data.RefDbRecipe;
      }
      if (defaultVal) {
        state.category = defaultVal.recipeForm.category;
        state.ingredientForm = defaultVal.ingredientForm || {};
        state.recipeForm = defaultVal.recipeForm;
        state.ingredientList = defaultVal.ingredientList;
        state.ingredientForm.name = defaultVal.fullname || defaultVal.name;
        state.ingredientForm.recipe_full = defaultVal.fullname || defaultVal.name;
        state.ingredientForm.recipes = defaultVal.name;
        state.ingredientForm.recipe = defaultVal.name;
        state.ingredientForm.full_name = defaultVal.fullname;
        state.ingredientForm.upc = defaultVal.barcode;

        // Normalize units into arrays so SEARCH_INGREDIENTS can safely read them
        const toArr = (u) => Array.isArray(u) ? u : (u ? [u] : []);
        const itemUnits = toArr(
          state.ingredientForm.units ||
          state.ingredientForm.unit  ||
          state.ingredientForm.unitList
        );
        state.ingredientForm.units    = itemUnits;
        state.ingredientForm.unit     = itemUnits;   // some paths read .unit
        state.ingredientForm.unitList = itemUnits;   // some paths read .unitList
        if (state.ingredientForm.unitid) {
          state.ingredientForm.unitid = String(state.ingredientForm.unitid);
        } else if (itemUnits.length === 1 && String(itemUnits[0]) !== "910") {
          state.ingredientForm.unitid = String(itemUnits[0]);
        } else {
          state.ingredientForm.unitid = "";
        }

        // Build measurementOptions like BARCODE_READ → handleUnitDropdown first
        let unitsOpts = handleUnitDropdown(state.recipeForm.category, {
          ...state.ingredientForm,
          units: itemUnits,
          unit: itemUnits,
          unitid: state.ingredientForm.unitid,
        }) || [];

        // Apply your category-specific overrides/guards
        const category = state.recipeForm.category;
        if (category === "03") {
          unitsOpts = unitsOpts.filter((u) => u && u.value !== "103" && u.value !== "104");
        } else if (category === "01") {
          unitsOpts = [{ value: "142", label: i18n.t("symptoms.ITEM_UNIT_TEXT") }];
          state.ingredientForm.unitid = "142";
        } else if ((category === "02" || category === "999") && unitsOpts.length === 0) {
          unitsOpts = foodunits();
        } else if (category === "04" && unitsOpts.length === 0) {
          const act_units = PCP_UNITS();
          unitsOpts = act_units.map((item) => ({ value: item._id, label: item.unit }));
        } else if (category === "05" && unitsOpts.length === 0) {
          const act_units = DRUG_UNITS();
          unitsOpts = act_units.map((item) => ({ value: item._id, label: item.unit }));
        } else if (category === "06" && unitsOpts.length === 0) {
          const act_units = SUP_UNITS();
          unitsOpts = act_units.map((item) => ({ value: item._id, label: item.unit }));
        } else if (category === "07" && unitsOpts.length === 0) {
          const act_units = LOC_UNITS();
          unitsOpts = act_units.map((item) => ({ value: item._id, label: item.unit }));
        }
        state.measurementOptions = Array.isArray(unitsOpts) ? unitsOpts : [];

        savedData(state.disabled.saveBtn, state.recipeForm.category)
      }
      buttonsChecker();
      if (!localStorage.getItem("unContributed")) {
        localStorage.removeItem("contDefault");
      }

      state.disabled.ingredientName = defaultVal ? false : true;
      state.disabled.ingredientsize = defaultVal ? false : true;
      state.disabled.ingredientunit = defaultVal ? false : true;
      if (state.category === "999" && !state.getRecipe) {
        if (
          state.ingredientList &&
          state.ingredientList.length > 1 &&
          state.recipeForm.recipe &&
          state.recipeForm.size
        ) {
          state.disabled.saveBtn = false;
        }
      } else if (state.category !== "999" && !state.getRecipe) {
        if (
          state.ingredientList &&
          state.ingredientList.length > 1 &&
          state.recipeForm.recipe
        ) {
          state.disabled.saveBtn = false;
        }
      }

      return { ...state };
    }
    case getStarted(GET_RECIPE):
      return {
        ...state,
        incompatibleIngredient: false,
        exactExistRecipeId: "",
        isLoading: true,
      };

    case GET_RECIPE: {
      // ===== Guards =====
      const item = action.item;
      if (!item) {
        console.warn("[GET_RECIPE] No item payload; ignoring.");
        return { ...state, isLoading: false };
      }
      if ((state.ingredientList || []).length > 0) {
        console.warn("[GET_RECIPE] Ignored because ingredientList is not empty (prompt flow should handle Add/Replace).");
        return { ...state, isLoading: false };
      }

      // ===== Normalize incoming =====
      const name = getRecipeName(item);
      const normalizedList = normalizeIncomingList(item) || [];

      // Hour→HH;MM display (per spec) seed backend fields once
      const convertedList = normalizedList.map((ing) => {
        const unitRaw = String(ing.unitid || (Array.isArray(ing.unit) ? ing.unit[0] : ""));
        const sizeRaw = String(ing.size || ing.value || "");

        // 1) Hours (102): if decimal AND >= 3h → display as HH;MM, keep original hours for backend
        const disp = convertHHMMForDisplay(sizeRaw, unitRaw);
        if (disp.unit === "445") {
          return {
            ...ing,
            unitid: "445",
            size: disp.display,           // e.g., "3;30"
            backendUnit: disp.backendUnit, // "102"
            backendSize: disp.backendScale // original decimal hours string
          };
        }

        // 2) Already HH;MM → compute backend numeric once
        if (unitRaw === "445" && /[:;]/.test(sizeRaw)) {
          const { unit, scale } = convertHHMMForBackend(sizeRaw, unitRaw);
          return { ...ing, backendUnit: unit, backendSize: scale };
        }

        // 3) All others (e.g., minutes 101) → passthrough
        return { ...ing, backendUnit: unitRaw, backendSize: sizeRaw };
      });

      // Build duplicateList from the normalized list (keep shapes consistent)
      const enrichedForDuplicate = convertedList.map((ing) => ({
        ...ing,
        recipe_full: ing.recipe_full || ing.fullname || ing.recipe,
        fullname: ing.fullname || ing.recipe,
      }));
      const duplicateList = orderIngredientList(enrichedForDuplicate);

      // Baselines & forms
      const recipeFormValue = {
        recipe: name,
        size: item.size,
        comment: item.comment || "",
      };

      const recipeForm = {
        ...state.recipeForm,
        _id: item._id || "",                                   // no suffix logic
        recipe: name,
        size: (item.size !== undefined && item.size !== null)
          ? item.size
          : state.recipeForm.size,                              // keep previous if undefined
        comment: item.comment || "",
      };

      // Flags from id + presence of list
      const { RefDbRecipe, customRecipe, customItem } = classifySelection(item);

      // Keep a normalized copy of the selected record
      const newList = { ...item, comment: item.comment || "" };

      // ===== Write state (no UI toggles here; buttonsChecker owns that) =====
      state = {
        ...state,
        isEditing: true,
        replaceAlert: false,            // no prompt in this path
        // NOTE: we intentionally do not set/getRecipe anymore
        newList,
        ingredientList: convertedList, // FULL REPLACE (even if empty)
        duplicateList,
        recipeFormValue,                // baseline for change detection
        recipeForm,                     // displayed form
        recipeNameBaseline: name,       // <<< last confirmed name for Cancel
        recipeIdBaseline: item._id || "",// <<< last confirmed ID for Cancel
        recipeHasIngredientBaseline: true, // always set to true in this 
        RefDbRecipe,
        customRecipe,
        customItem,
      };

      // Single source of truth for enables/flags
      buttonsChecker();

      return { ...state, isLoading: false };
    }

    case SEARCH_INGREDIENTS: {
      // keep: upc404/contribute blocks, flags, etc.
      const isContributedItem =
        !!state.ingredientForm.upc &&
        (!state.ingredientForm._id || String(state.ingredientForm._id).slice(0, 1) !== "1");

      // // === goSearch decision (spec) ===
      let goSearch = true;
      const newName = action.recipe || "";

      // === common resets kept from your code (non-unit) ===
      state.partialResult = [];
      state.cancelMode = false;
      state.replaceItemsAdded = false;
      state.kitData = [];
      state.duplicateEntry = false;
      state.updateRecipeData = false;

      if (goSearch) {
        // keep UI/text resets as you had
        state.sameIngredient = false;
        state.ingredientForm.size = "";                 // amount cleared on typing
        state.amountReseter = !state.amountReseter;
        state.ingredientForm.recipe_full = newName;
        state.ingredientForm.fullname = newName;
        state.ingredientForm.full_name = newName;
        state.ingredientForm.ingredients_text = "";
        state.ingredientForm.recipes = newName;
        state.ingredientForm.recipe = newName;

        // ✅ Item name typed manually → invalidate old recipe ingredients
        state.recipeIngredient = [];

        const category = state.recipeForm.category;

        // ---------- UNIT LOGIC (spec) ----------
        // Helper: normalize options & mirror into unitList
        const setOptions = (opts) => {
          const normalized = Array.isArray(opts)
            ? opts.map(u => ({ value: String(u.value), label: String(u.label || "") }))
            : [];
          state.measurementOptions = normalized;
          state.ingredientForm.unitList = normalized.map(u => u.value);
          // keep a mirror for downstream if they rely on it
          state.ingredientForm.units = [...state.ingredientForm.unitList];
          return normalized;
        };
        // Helper: decide if only one non-910 unit exists
        const isSingleNon910 = (opts) =>
          Array.isArray(opts) &&
          opts.length === 1 &&
          String(opts[0].value) !== "910";

        // A) Contributed item & NOT crossClicked  → keep id/upc/options/lists; only clear amount & maybe selected unit
        if (isContributedItem && !action.crossClicked) {
          // refresh text/time fields only; do NOT clear _id/upc/options per spec
          // Clear selected unit only if there are >1 options
          const curOpts = Array.isArray(state.measurementOptions) ? state.measurementOptions : [];
          if (curOpts.length > 1) {
            state.ingredientForm.unitid = "";  // force re-pick when multiple
          } else if (isSingleNon910(curOpts)) {
            // keep the only non-910 selection if already set; otherwise auto-set it
            if (String(state.ingredientForm.unitid || "") !== String(curOpts[0].value)) {
              state.ingredientForm.unitid = String(curOpts[0].value);
            }
          } // if only "910", leave unitid as-is (no auto-select)

        // B) Non-contributed OR crossClicked  → clear everything; rebuild options from getCategoryUnits
        } else {
          state.ingredientForm._id = "";
          state.ingredientForm.upc = "";

          // clear amount & selected unit and previous options
          state.ingredientForm.size = "";
          state.ingredientForm.unitid = "";
          state.measurementOptions = [];
          state.ingredientForm.unitList = [];
          state.ingredientForm.units = [];

          // build fresh options by category
          const fresh = getCategoryUnits(category);
          const opts = setOptions(fresh);

          // For Symptom (01) → force 142 (already returned by getCategoryUnits)
          if (String(category) === "01") {
            state.ingredientForm.unitid = "142";
          } else if (isSingleNon910(opts)) {
            // For other categories: auto-select only if single *and* not 910
            state.ingredientForm.unitid = String(opts[0].value);
          } else {
            state.ingredientForm.unitid = "";
          }
        }
        // ---------- END UNIT LOGIC ----------

        // keep original id clear on typing for non-contributed
        if (!isContributedItem) {
          state.ingredientForm._id = "";
        }
      }

      // ===== Removed legacy sameIngredient scan per your instruction =====

      // keep: crossClicked branch
      if (action.crossClicked) {
        state.ingredientForm = {};
        state.ingredientForm = { ...state.ingredientForm, size: "" };
      }

      // keep: upc404 passthrough
      if (state.upc404 && !action.crossClicked) {
        state.ingredientForm.upc = state.upc404Value;
      }

      // keep: contributeRedirectionAlert passthrough
      if (action.contributeRedirectionAlert) {
        state.contributeRedirectionAlert = false;
        state.ingredientForm = {
          ...state.ingredientForm,
          unit: state.ingredientForm.unit ? state.ingredientForm.unit : "",
          units: state.ingredientForm.units ? state.ingredientForm.units : "",
        };
      }

      state.scaleOptions = []; // preserved
      state.amounNewValue = "";
      state.upc404 = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      state.itemChanged = detectIngredientChanged(state.ingredientForm, state.ingredientSelected);

      state.ingredientFormPrevious = {}
      buttonsChecker();
      state.barcodeScanned = false;
      if (!_.isEmpty(state.ingredientSelected)) {
        state.cancelMode = true;
        state.updateMode = false;
      }
      return { ...state };
    }

    case getStarted(SEARCH_RECIPES):
      return { ...state, isSuggestLoading: true };

    case SEARCH_RECIPES:
      // Check C
      state.duplicateEntry = false;
      state.replaceItemsAdded = false;
      state.updateRecipeData = false;
      state.customRecipe = false;
      state.UpdateHistoricalData = false;
      let goSearch = true;
      if (action.recipe.length <= 1 && state.ingredientList.length > 0) {
        state.newList = {
          ...state.newList,
          recipe: state.recipeForm.recipe,
        };
      }
      let itemName = action.recipe;
      let itemSname = state.recipeForm.recipe;
      let hasC2 = itemName.slice(-2);
      let hasC1 = itemName.slice(-1);
      if (hasC2 === "(C" || hasC1 === "(") {
        if (itemSname && itemSname.includes(itemName)) {
          goSearch = false;
        } else {
          goSearch = true;
        }
      } else {
        goSearch = true;
      }

      if (state.recipeForm.recipe != action.recipe) {
        if (goSearch) {
          state.firstChange = true;
          state.recipeForm._id = "";
        }
      }
      if (!action.recipe) {
        state.recipeForm.recipeName = state.recipeForm.recipe;
        state.newList.recipe_full = state.recipeForm.recipe;
      }
      state.recipeForm.recipe = action.recipe;
      buttonsChecker();
      return { ...state };

    case getEnded(SEARCH_RECIPES):
      return { ...state, isSuggestLoading: false, lastSuggestLoadedAt: Date.now() };

    case COMMIT_TYPED_RECIPE_NAME: {
      const name = action.name || "";
      if (!name) {
        return { ...state };    
      }    // nothing to do

      // This is a "typed-only" acceptance → no ID, no list
      const baselineId = "";        // important: keep id empty

      // Flags from "no id + no list" → new/custom item text
      const { RefDbRecipe, customRecipe, customItem } =
        classifySelection({ _id: baselineId });

      state = {
        ...state,
        // baselines used by Cancel
        recipeNameBaseline: name,
        recipeIdBaseline: baselineId,
        recipeHasListBaseline: false,

        // adopt flags derived from the typed acceptance
        RefDbRecipe,
        customRecipe,
        customItem,
      };

      // single source of truth for UI toggles
      buttonsChecker();
      return { ...state };
    }

    case RECIPE_ADD_ITEM:
      const unitAdd = String(action.item.unitid || "");
      const sizeAdd = String(action.item.size || "");

      if (unitAdd === "445") {
        const conv = convertHHMMForBackend(sizeAdd, unitAdd);
        action.item.backendUnit = conv.unit;   // e.g., "445"
        action.item.backendSize = conv.scale;  // numeric minutes
      } else {
        action.item.backendUnit = unitAdd;
        action.item.backendSize = sizeAdd;
      }

      // Add C
      state.ingredientForm.ingredients_text =
        action.item.ingredients_text || "";
      let itemID = "";
      var newData = [];

      // Determine whether it's custom or RefDB
      const isNewCustomAdd =
        (!action.item._id || action.item._id.length === 0) &&
        (!action.item.upc || action.item.upc.length === 0);

      action.item.recipe_full = action.item.recipe_full.replace(/\s+/g, " ").trim(); // Remove double space and trailing space

      if (isNewCustomAdd) {
        const CaseInsensitiveName = action.item.recipe_full.toLowerCase();

        if (CaseInsensitiveName.endsWith(" (c)")) {
          // If ends with " (C)", remove the space before (C)
          action.item.recipe_full = action.item.recipe_full.slice(0, -4) + " (C)";
        } else if (CaseInsensitiveName.endsWith("(c)")) {
          // if there's "(C)", just remove and add back. This handles the case of switching lower case "(c)" adding by user (if any) to the standard upper case "(C)"
          action.item.recipe_full = action.item.recipe_full.slice(0, -3) + " (C)";
        } else if (!CaseInsensitiveName.endsWith("(c)")) {
          // If there's no "(C)", append "(C)"
          action.item.recipe_full += " (C)";
        }
        action.item.recipe_full = action.item.recipe_full;
        action.item.recipe = action.item.recipe_full;
        action.item.recipes = action.item.recipe_full;
        action.item.unitid = state.ingredientForm.unitid;
      }

      action.item._id = action.item._id ? String(action.item._id) : ""; // ensure key exists
      if (!action.item.upc) delete action.item.upc;                     // keep state tidy

      // End C

      var updateFlag = false;
      if (!state.ingredientList <= 0) {
        newData = state.ingredientList.map((item, index) => {
          if (action.item._id) {
            if (item._id == action.item._id) {
            } else {
              return item;
            }
          } else {
            if (
              item.recipe_full.toString().toLowerCase().trim() ==
              action.item.recipe_full.toString().toLowerCase().trim() &&
              state.selectedIndex &&
              state.selectedIndex == index
            ) {
              updateFlag = true;
              return action.item;
            } else {
              updateFlag = false;
              return item;
            }
          }
        });
      }
      if (state.getRecipe) {
        state.addedItem = true;
      }
      if (!updateFlag) {
        newData = [...state.ingredientList, action.item];
      }

      // ✅ Seed baseline. This is the the Recipe Name that we will revert to when user clicks Cancel for the "Add or Replace Ingredient" prompt 
      if (state.recipeFormValue || state.recipeFormValue.recipe) {
        state.recipeFormValue = {
          recipe: (state.recipeForm && state.recipeForm.recipe) || "",
          size:   (state.recipeForm && state.recipeForm.size)   || "",
          comment:(state.recipeForm && state.recipeForm.comment)|| "",
        };
      }

      // (Optional, extra safety: capture previous name once)
      if (state.previousRecipe || state.previousRecipe.recipe == null) {
        state.previousRecipe = {
          ...(state.previousRecipe || {}),
          recipe: (state.recipeForm && state.recipeForm.recipe) || "",
        };
      }

      state.ingredientList = newData;
      state.newList = {
        ...state.newList,
        recipe: state.recipeForm.recipe,
      };

      state.ingredientForm = {};
      state.ingredientSelected = {};
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.firstChange = true;
      state.barcodeScanned = false;
      state.measurementOptions = [];
      state.scaleOptions = [];
      state.recipeForm = {
        ...state.recipeForm,
        recipeName: state.recipeForm.recipe,
      };
      state.itemChanged = false;
      state.outOfRange = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();

      return { ...state };
    case RECIPE_SAVE_ITEM:
      var unitUpdate = String(action.item.unitid || "");
      var sizeUpdate = String(action.item.size || "");

      if (unitUpdate === "445") {
        const conv = convertHHMMForBackend(sizeUpdate, unitUpdate);
        action.item.backendUnit = conv.unit;   // e.g., "445"
        action.item.backendSize = conv.scale;  // numeric minutes
      } else {
        action.item.backendUnit = unitUpdate;
        action.item.backendSize = sizeUpdate;
      }

      state.measurementOptions = [];
      // Add C
      itemID = "";
      // Determine whether it's custom or RefDB
      const isNewCustomUpdate =
        (!action.item._id || action.item._id.length === 0) &&
        (!action.item.upc || action.item.upc.length === 0);

      action.item.recipe_full = action.item.recipe_full.replace(/\s+/g, " ").trim(); // Remove double space and trailing space

      if (isNewCustomUpdate) {
        const CaseInsensitiveName = action.item.recipe_full.toLowerCase();

        if (CaseInsensitiveName.endsWith(" (c)")) {
          // If ends with " (C)", remove the space before (C)
          action.item.recipe_full = action.item.recipe_full.slice(0, -4) + " (C)";
        } else if (CaseInsensitiveName.endsWith("(c)")) {
          // if there's "(C)", just remove and add back. This handles the case of switching lower case "(c)" adding by user (if any) to the standard upper case "(C)"
          action.item.recipe_full = action.item.recipe_full.slice(0, -3) + " (C)";
        } else if (!CaseInsensitiveName.endsWith("(c)")) {
          // If there's no "(C)", append "(C)"
          action.item.recipe_full += " (C)";
        }
        action.item.recipe_full = action.item.recipe_full;
        action.item.recipe = action.item.recipe_full;
        action.item.recipes = action.item.recipe_full;
        action.item.unitid = state.ingredientForm.unitid;
      }

      action.item._id = action.item._id ? String(action.item._id) : ""; // ensure key exists
      if (!action.item.upc) delete action.item.upc;                     // keep state tidy

      // End C

      ingredientList = [...state.ingredientList];
      ingredientList[state.selectedIndex] = action.item;
      ingredientList[state.selectedIndex].isSelected = false;

      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.selectedIndex = -1;
      state.ingredientForm = {};
      state.ingredientList = ingredientList;
      state.ingredientSelected = {};
      state.firstChange = true;
      state.updateRecipe = true;
      // state.customRecipeHasRefDbItem = false;
      state.scaleOptions = [];
      if (state.category == "999") {
        if (state.recipeForm.size && state.ingredientList.length > 1) {
          state.disabled.saveBtn = false;
        } else {
          state.disabled.saveBtn = true;
        }
      } else {
        if (state.ingredientList.length > 1) {
          state.disabled.saveBtn = false;
        }
      }
      state.updateRecipeData = false;
      state.itemChanged = false;
      state.outOfRange = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      state.ingredientForm = {};
      return { ...state };
    case RECIPE_DELETE:
      ingredientList = [...state.ingredientList];
      _.pullAt(ingredientList, action.item);

      for (const ingredient of ingredientList) {
        ingredient.isSelected = false;
      }

      //reset form
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.ingredientForm = {};
      state.measurementOptions = [];
      state.kitData = [];
      state.ingredientSelected = {};
      state.selectedIndex = -1;
      state.ingredientList = ingredientList;
      state.scaleOptions.length = 0;
      state.firstChange = true;
      state.cancelMode = false;
      state.itemChanged = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      return { ...state };
    case RESET_ID:
      state.exactExistRecipeId = "";
      return { ...state };

    case RECIPE_CLEAR:
      state.recipeForm = {};
      state.recipeFormValue = {};
      state.ingredientForm = {};
      state.ingredientList = [];
      state.hiddenIngredientList = [];
      state.deletedRecipeName = [];
      state.ingredientOptions = [];
      state.updateRecipeData = false;
      localStorage.removeItem("recipePageTitle");
      localStorage.removeItem("logoutWithoutSaveRegimen");
      localStorage.removeItem("logoutWithoutSaveRecipe");
      state.firstChange = false;
      state.category = "";
      state.sameIngredient = false;
      state.duplicateItem = false;
      state.ingredientSelected = {};
      state.amounNewValue = "";
      state.measurementOptions = [];
      state.isEditing = false;
      state.getRecipe = false;
      state.outOfRange = false;
      state.customRecipe = false;
      // state.previouscustomRecipe = false;
      state.RefDbRecipe = false;
      state.duplicateEntry = false;
      state.ingredientsAdded = false;
      state.replaceItemsAdded = false;
      // state.customRecipeHasRefDbItem = false;
      state.incompatibleHiddenIngredient = false;
      state.excessiveNestedRecipe = false;
      state.incompatibleIngredient = false;
      state.comment = "";
      state.exactExistRecipeId = "";
      let defaultData = localStorage.getItem("contDefault");
      let defaultVal = JSON.parse(defaultData);
      if (defaultVal) {
        state.category = defaultVal.recipeForm.category;
        state.ingredientForm = defaultVal.ingredientForm
          ? defaultVal.ingredientForm
          : {};
        state.recipeForm = defaultVal.recipeForm;
        state.ingredientList = defaultVal.ingredientList;
        state.ingredientForm.name = defaultVal.fullname || defaultVal.name;
        state.ingredientForm.recipe_full =
          defaultVal.fullname || defaultVal.name;
        state.ingredientForm.recipes = defaultVal.name;
        state.ingredientForm.recipe = defaultVal.name;
        state.ingredientForm.full_name = defaultVal.fullname;
        state.ingredientForm.upc = defaultVal.barcode;
        category = state.recipeForm.category;
        units = [];
        if (category == "03") {
          let act_units = ACTIVITY_UNITS();
          act_units.map((item) => {
            if (item._id == "103") {
              return false;
            } else if (item._id == "104") {
              return false;
            } else {
              units.push({ value: item._id, label: item.unit });
            }
          });
        } else if (category == "01") {
          units = [{ value: "142", label: i18n.t("symptoms.ITEM_UNIT_TEXT") }];
          state.ingredientForm.unitid = "142";
        } else if (category == "02" || category == "999") {
          units = foodunits();
        } else if (category == "04") {
          let act_units = PCP_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
        } else if (category == "05") {
          let act_units = DRUG_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
        } else if (category == "06") {
          let act_units = SUP_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
        } else if (category == "07") {
          let act_units = LOC_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
        }
        state.measurementOptions = units;
      }
      state.amountReseter = !state.amountReseter;
      state.itemChanged = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      state.amountReseter = !state.amountReseter;
      state.updateRecipe = false;
      state.previousDisable = {};
      localStorage.removeItem("contDefault");
      return {
        ...state,
        UpdateHistoricalData: false,
        selectedIndex: -1,
        cancelMode: false,
        deleteMode: false,
        saveSuccess: false,
      };
    case ON_CHANGE_INGREDIENTFORM:
      state.ingredientForm[action.event.target.name] =
        action.event.target.value;
      if (
        (state.ingredientForm.unit != "" ||
          state.ingredientForm.unitid != "") &&
        state.category !== "999"
      ) {
        let sunits;
        if (state.category === "01") {
          sunits = SYMPTOM_UNITS_NEW();
        } else if (state.category === "02") {
          sunits = FOOD_UNITS();
        } else if (state.category === "04") {
          sunits = PCP_UNITS();
        } else if (state.category === "05") {
          sunits = DRUG_UNITS();
        } else if (state.category === "06") {
          sunits = SUP_UNITS();
        } else if (state.category === "03") {
          sunits = ACTIVITY_UNITS();
        } else if (state.category === "07") {
          sunits = LOC_UNITS();
        }
        let scalList = [];
        for (const sunit of sunits) {
          if (state.ingredientForm.unitid == sunit._id) {
            if (sunit.label) {
              for (let index = 0; index < sunit.value.length; index++) {
                scalList.push({
                  value: sunit.value[index],
                  label: sunit.label[index],
                });
              }
            } else {
              if (sunit.description) {
                scalList.desc = sunit.description;
                scalList.min = sunit.value[0];
                scalList.max = sunit.value[1];
              }
            }
          }
        }
        state.scaleOptions = scalList;

        // Checking for the allowed number range
        let scaleValue = state.ingredientForm.size.trim();
        let parsedValue = NaN;

        // Check for mixed fraction: "1 & 1/2" or "1 1/2"
        let mixedFraction = scaleValue.match(/^(\d+)\s*[& ]\s*(\d+)\/(\d+)$/);
        if (mixedFraction) {
          const whole = parseInt(mixedFraction[1], 10);
          const numerator = parseInt(mixedFraction[2], 10);
          const denominator = parseInt(mixedFraction[3], 10);
          parsedValue = whole + numerator / denominator;
        } else {
          // Check for pure fraction: "1/2"
          let simpleFraction = scaleValue.match(/^(\d+)\/(\d+)$/);
          if (simpleFraction) {
            const numerator = parseInt(simpleFraction[1], 10);
            const denominator = parseInt(simpleFraction[2], 10);
            parsedValue = numerator / denominator;
          } else {
            // Try parsing as a float (normal number)
            parsedValue = parseFloat(scaleValue);
          }
        }

        // Flag for "Value too Small or Too Large" prompt
        if (!isNaN(parsedValue) && (parsedValue < scalList.min || parsedValue > scalList.max)) {
          const cleanedNewName = (state.ingredientForm.name || "").trim().toLowerCase().replace(/\(c\)$/i, "").trim();
          const cleanedOriginalName = (state.ingredientSelected.name || "").trim().toLowerCase().replace(/\(c\)$/i, "").trim();

          let hasNameChanged;
          if (state.ingredientSelected._id) {
            hasNameChanged = !state.ingredientForm._id || state.ingredientSelected._id !== state.ingredientForm._id;
          } else if (state.ingredientSelected.upc) {
            hasNameChanged = !state.ingredientForm.upc || state.ingredientSelected.upc !== state.ingredientForm.upc;
          } else {
            hasNameChanged = cleanedNewName !== cleanedOriginalName;
          }

          const unitChanged = (state.ingredientForm.unitid || "").toString() !== (state.ingredientSelected.unitid || "").toString();
          const scaleChanged = (state.ingredientForm.size || "").toString().trim() !== (state.ingredientSelected.size || "").toString().trim();

          if (hasNameChanged || unitChanged || scaleChanged) {
            state.outOfRange = true;
          } else {
            state.outOfRange = false;
          }
        } else {
          state.outOfRange = false;
        }
      }

      if (
        action.event.target.name === "size" &&
        action.event.target.value.length === 1
      ) {
        let numbers = "0123456789";
        let scaleVal = action.event.target.value.toString();
        if (numbers.indexOf(scaleVal) > -1) {
          state.ingredientForm.size = action.event.target.value;
        } else {
          state.ingredientForm.size = "";
          state.amountReseter = !state.amountReseter;
          state.amounNewValue = "";
        }
      }

      state.itemChanged = detectIngredientChanged(state.ingredientForm, state.ingredientSelected);

      const prev = state.ingredientFormPrevious || {};
      const current = state.ingredientForm;

      const unitChangedToNonHHMM = prev.unit === "445" && current.unitid !== "445";
      const unitChangedToHHMM = prev.unit !== "445" && current.unitid === "445";

      // Deactivate hhmmMode if user changes unit away from 445
      if (unitChangedToNonHHMM) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
        state.ingredientForm.size = "";
        state.amounNewValue = "";
      }

      // Activate hhmmMode if user manually selects 445 (HH:MM unit)
      if (unitChangedToHHMM) {
        state.hhmmMode = true;
        state.amountReseter = !state.amountReseter;
        state.ingredientForm.size = "";
        state.amounNewValue = "";
      }

      // ✅ Update the stored previous values at the end
      state.ingredientFormPrevious = {
        name: current.name || "",
        category: current.category || "",
        unit: current.unitid || ""
      };

      buttonsChecker();
      return { ...state };
    case ON_CHANGE_MYRECIPENTFORM:
      state.recipeForm[action.event.target.name] = action.event.target.value;
      const { ingredientForm } = state;
      state.addedItem = false;
      buttonsChecker();
      return { ...state };

    case INGREDIENT_OPTION_SELECTED:
      state.ingredientFormPrevious = {}
      state.replaceItemsAdded = false;
      state.partialResult = [];
      state.measurementOptions = [];

      state.ingredientForm.ingredients_text = action.item.ingredients_text || "";

      if (Array.isArray(action.item.ingredients) && action.item.ingredients.length > 0) {
        state. recipeIngredient = action.item.ingredients;
      } else {
        state. recipeIngredient = [];
      }

      let cat = state.recipeForm.category;

      if (cat === "02" || cat === "999") {
        // Meal Set & Food Recipe
        state.ingredientForm.recipes = action.item.recipes;
        state.ingredientForm.recipe = action.item.recipe;
        state.ingredientForm.recipe_full = action.item.recipe_full;
        state.ingredientForm.full_name = action.item.recipe_full;
        state.ingredientForm.name = action.item.recipe_full;
        state.ingredientForm._id = action.item._id;
      } else if (cat === "01") {
        // Symptom
        const titleOrDisplay = state.barcodeScanned ? action.item.title : action.item.displayname;
        const titleOrName    = state.barcodeScanned ? action.item.title : action.item.name;

        state.ingredientForm.recipes = titleOrDisplay;
        state.ingredientForm.recipe = titleOrName;
        state.ingredientForm.recipe_full = titleOrName;
        state.ingredientForm.fullname = titleOrName;
        state.ingredientForm.full_name = titleOrName;
        state.ingredientForm.name = titleOrName;
        state.ingredientForm._id         = action.item._id;
      } else {
        // Activity / PCP / Drug / Supplement / Location
        const recipeOrName      = state.barcodeScanned ? action.item.recipe : action.item.name;
        const Fullname   = state.barcodeScanned ? action.item.recipe_full : action.item.fullname;
        const recipeOrFullname  = state.barcodeScanned ? action.item.recipe : action.item.fullname;

        state.ingredientForm.recipes = recipeOrName;
        state.ingredientForm.recipe = recipeOrFullname;
        state.ingredientForm.recipe_full = Fullname;
        state.ingredientForm.full_name = Fullname;
        state.ingredientForm.name = Fullname;
        state.ingredientForm._id = action.item._id;
      }

      // Ensure UPC shows in the name field (grey append)
      {
        const idStr = String((action.item && action.item._id) || "");
        if (action.item && action.item.upc && idStr.charAt(0) !== "1") {
          // mimic old behavior: only set for non-"1..." ids
          state.ingredientForm.upc = action.item.upc;
        }
      }

      // ----------------------------
      // 2) Normalize backend-provided unit list per category
      //    (strictly follow spec: use the array the backend sent)
      // ----------------------------
      let unitListRaw = [];
      if (cat === "01") {
        // Symptom uses "unitsid"
        unitListRaw = action.item.unitsid;
      } else if (cat === "03") {
        // Activity uses "unit"
        unitListRaw = action.item.unit;
      } else {
        // Food/Recipe/PCP/Drug/Supp/Location use "units"
        unitListRaw = action.item.units;
      }

      // Normalize IDs to strings
      const unitList = (unitListRaw || []).map((u) => String(u));

      // ----------------------------
      // 3) Build dropdown options via your helper (handles: blank, ["910"], or explicit lists)
      // ----------------------------
      state.measurementOptions = handleUnitDropdown(cat, { unitList });

      // Persist the raw ID list on the form so re-selecting from Display Area can rebuild consistently
      state.ingredientForm.unitList = unitList;
      // Keep .units as IDs (not option objects) for other code paths that read it
      state.ingredientForm.units = unitList;

      // ----------------------------
      // 4) Autoselect rule: only when exactly one non-910 unit
      // ----------------------------
      if (unitList.length === 1 && unitList[0] !== "910") {
        state.ingredientForm.unitid = unitList[0];
      } else {
        state.ingredientForm.unitid = "";
      }

      // ----------------------------
      // 5) UPC rule (preserve your prior behavior)
      // ----------------------------
      if (action.item && action.item._id) {
        const first = String(action.item._id).slice(0, 1);
        if (first !== "1" && action.item.upc) {
          state.ingredientForm.upc = action.item.upc;
        }
      }

      // ----------------------------
      // 6) Scale options (Symptom only)
      // ----------------------------
      if (cat === "01") {
        // If getScaleList expects unit ID array, pass unitList
        state.scaleOptions = getScaleList(unitList);
      } else {
        state.scaleOptions = [];
      }

      // Reset size when scale options exist (same as before)
      if (state.scaleOptions.length) {
        state.ingredientForm = {
          ...state.ingredientForm,
          size: ""
        };
      }
      state.ingredientForm.size = "";

      state.amountReseter = !state.amountReseter;
      state.outOfRange = false;
      state.hhmmMode = false;

      buttonsChecker();
      if (!_.isEmpty(state.ingredientSelected)) {
        state.cancelMode = true;
        state.updateMode = false;
      }
    
      return { ...state };

    case INGREDIENT_KIT_SELECTED:
      let kitData = action.item.items;
      state.duplicateEntry = false;
      state.ingredientForm.unitid = "";
      state.ingredientForm.size = "";
      state.amountReseter = !state.amountReseter;
      state.hhmmMode = false;

      state.outOfRange = false;
      kitData = kitData.map((item) => {
        return {
          recipe: item.recipe_full || item.recipe || item.fullname, //item.recipe_full || item.recipe,
          recipe_full: item.recipe_full || item.fullname, // item.recipe_full || item.ingredients_text || item.fullname
          name: item.name,
          recipes: item.name,
          size: item.value, // item.size
          unitid: item.unitid || (item.unit && item.unit[0]),
          units: item.unit, // item.units
          unitList: item.unit,
          _id: item._id,
          ingredients_text: item.ingredients_text,
          upc: item.upc || null,
        };
      });
      
      state.kitData = kitData;
      state.ingredientForm.recipes = action.item.recipe;
      state.ingredientForm.recipe = action.item.recipe_full;
      state.ingredientForm.recipe_full =
        action.item.recipe_full || action.item.fullname;
      state.ingredientForm.full_name = action.item.recipe_full;
      state.ingredientForm.fullname = action.item.fullname;
      if (state.ingredientList && state.ingredientList.length > 0) {
        state.kitData.map((item) => {
          state.ingredientList.map((recipe) => {
            if (
              item.recipe_full === recipe.recipe_full ||
              (item.upc && recipe.upc && item.upc === recipe.upc) ||
              (item._id && recipe._id && item._id === recipe._id)
            ) {
              state.duplicateEntry = true;
            }
          });
          if (item.recipe_full === state.recipeForm.recipe) {
            state.duplicateEntry = false;
          }
        });
      }
      state.itemChanged = detectIngredientChanged(state.ingredientForm, state.ingredientSelected);
      buttonsChecker();
      state.measurementOptions = [];
      if (!_.isEmpty(state.ingredientSelected)) {
        state.cancelMode = false;
        state.updateMode = true;
      }
      return { ...state, scaleOptions: [] };
    case INGREDIENT_KIT_ADDED:
      const kitRawAdd = Array.isArray(state.kitData) ? state.kitData : [];

      const kitAdd = kitRawAdd.map((it) => {
        const unitRaw = String(it.unitid || (Array.isArray(it.unit) ? it.unit[0] : ""));
        const sizeRaw = String(it.size || it.value || "");

        // 1) Hours (102) → HH;MM for display IF decimal and >= 3h
        const disp = convertHHMMForDisplay(sizeRaw, unitRaw);
        if (disp.unit === "445") {
          return {
            ...it,
            // Display becomes HH;MM
            unitid: "445",
            size: disp.display,
            // Keep original hours for payload
            backendUnit: disp.backendUnit,   // "102"
            backendSize: disp.backendScale,  // original decimal hours
          };
        }

        // 2) Already HH;MM → compute backend payload once
        // Only convert when the HH:MM unit is selected AND the value looks like HH;MM or HH:MM
        if (unitRaw === "445" && /[:;]/.test(sizeRaw)) {
          const { unit, scale } = convertHHMMForBackend(sizeRaw, unitRaw);
          return { ...it, backendUnit: unit, backendSize: scale };
        }

        // 3) All other units (e.g., minutes 101) → pass through
        return { ...it, backendUnit: unitRaw, backendSize: sizeRaw };
      });

      // ✅ Seed baseline. This is the the Recipe Name that we will revert to when user clicks Cancel for the "Add or Replace Ingredient" prompt 
      if (state.recipeFormValue || state.recipeFormValue.recipe) {
        state.recipeFormValue = {
          recipe: (state.recipeForm && state.recipeForm.recipe) || "",
          size:   (state.recipeForm && state.recipeForm.size)   || "",
          comment:(state.recipeForm && state.recipeForm.comment)|| "",
        };
      }

      // (Optional, extra safety: capture previous name once)
      if (state.previousRecipe || state.previousRecipe.recipe == null) {
        state.previousRecipe = {
          ...(state.previousRecipe || {}),
          recipe: (state.recipeForm && state.recipeForm.recipe) || "",
        };
      }

      state.ingredientList = state.ingredientList.concat(kitAdd);

      state.ingredientForm = { unitid: "", recipe_full: "" };
      state.firstChange = true;
      state.itemChanged = false;
      buttonsChecker();
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.measurementOptions = [];
      state.scaleOptions = [];
      state.kitData = [];
      return { ...state };

    case INGREDIENT_KIT_UPDATED:
      const kitRawUpdate = Array.isArray(state.kitData) ? state.kitData : [];

      const kitUpdate = kitRawUpdate.map((it) => {
        const unitRaw = String(it.unitid || (Array.isArray(it.unit) ? it.unit[0] : ""));
        const sizeRaw = String(it.size || it.value || "");

        // 1) Hours (102) → HH;MM for display IF decimal and >= 3h
        const disp = convertHHMMForDisplay(sizeRaw, unitRaw);
        if (disp.unit === "445") {
          return {
            ...it,
            // Display becomes HH;MM
            unitid: "445",
            size: disp.display,
            // Keep original hours for payload
            backendUnit: disp.backendUnit,   // "102"
            backendSize: disp.backendScale,  // original decimal hours
          };
        }

        // 2) Already HH;MM → compute backend payload once
        // Only convert when the HH:MM unit is selected AND the value looks like HH;MM or HH:MM
        if (unitRaw === "445" && /[:;]/.test(sizeRaw)) {
          const { unit, scale } = convertHHMMForBackend(sizeRaw, unitRaw);
          return { ...it, backendUnit: unit, backendSize: scale };
        }

        // 3) All other units (e.g., minutes 101) → pass through
        return { ...it, backendUnit: unitRaw, backendSize: sizeRaw };
      });

      state.ingredientList.splice(action.index, 1, ...kitUpdate);
      state.ingredientForm = { unitid: "", recipe_full: "" };
      state.firstChange = true;
      state.selectedIndex = -1;
      state.itemChanged = false;

      // ✅ Seed baseline. This is the the Recipe Name that we will revert to when user clicks Cancel for the "Add or Replace Ingredient" prompt 
      if (state.recipeFormValue || state.recipeFormValue.recipe) {
        state.recipeFormValue = {
          recipe: (state.recipeForm && state.recipeForm.recipe) || "",
          size:   (state.recipeForm && state.recipeForm.size)   || "",
          comment:(state.recipeForm && state.recipeForm.comment)|| "",
        };
      }

      // (Optional, extra safety: capture previous name once)
      if (state.previousRecipe || state.previousRecipe.recipe == null) {
        state.previousRecipe = {
          ...(state.previousRecipe || {}),
          recipe: (state.recipeForm && state.recipeForm.recipe) || "",
        };
      }

      buttonsChecker();
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.ingredientForm = {};
      state.ingredientSelected = {};
      state.scaleOptions = [];
      state.updateMode = false;
      state.cancelMode = false;
      state.measurementOptions = [];
      state.kitData = [];
      return { ...state };

    case RECIPE_TO_BODYMAP:
      localStorage.setItem("bodystate", JSON.stringify(state));
      localStorage.setItem("bodyreturn", "recipe");
      window.location = "/bodymap";
      return { ...state };
    case RECIPE_FROM_BODYMAP:
      let bodyState = localStorage.getItem("bodystate");
      bodyState = JSON.parse(bodyState);

      // Restore FIRST for accurate unsavedAlertData computation
      Object.assign(state, bodyState);

      localStorage.removeItem("bodystate");
      localStorage.removeItem("bodyreturn");
      localStorage.removeItem("bodyMapSymptom");

      buttonsChecker();

      return { ...bodyState };
    case SELECTED_CATEGORY:
      state.kitData = [];
      state.selectedCat = action.value;
      return {
        ...state,
      };
    case REPLACE_OR_ADD_RECIPE: {
      // Guard
      if (!action.recipe) {
        console.warn("[Reducer] REPLACE_OR_ADD_RECIPE missing recipe payload");
        return { ...state, replaceAlert: false };
      }

      // Snapshot & common values
      const prevComment = state.recipeForm && state.recipeForm.comment || "";
      const incoming = action.recipe;
      const name = getRecipeName(incoming);
      const normalized = normalizeIncomingList(incoming) || [];

      // Map for display/backend once, per item
      const normalizedConverted = normalized.map((it) => {
        const unitRaw = String(it.unitid || (Array.isArray(it.unit) ? it.unit[0] : ""));
        const sizeRaw = String(it.size || it.value || "");

        // 1) Hours (102): if decimal AND >= 3h → show HH;MM, keep original hours for payload
        const disp = convertHHMMForDisplay(sizeRaw, unitRaw);
        if (disp.unit === "445") {
          return {
            ...it,
            unitid: "445",
            size: disp.display,           // e.g., "3;30"
            backendUnit: disp.backendUnit, // "102"
            backendSize: disp.backendScale // original decimal hour string
          };
        }

        // 2) Already HH;MM → compute backend numeric once
        if (unitRaw === "445" && /[:;]/.test(sizeRaw)) {
          const { unit, scale } = convertHHMMForBackend(sizeRaw, unitRaw);
          return { ...it, backendUnit: unit, backendSize: scale };
        }

        // 3) Others (e.g., minutes 101) → passthrough
        return { ...it, backendUnit: unitRaw, backendSize: sizeRaw };
      });

      // We never mutate arrays in place
      let nextIngredientList = state.ingredientList || [];
      let nextDuplicateList  = state.duplicateList || [];

      if (action.status === "add") {
        // 1) Append converted list (no de-dupe)
        nextIngredientList = [...nextIngredientList, ...normalizedConverted];

        // 2) Size & comment
        const nextSize = Number(incoming.size || 0) + Number(state.recipeForm && state.recipeForm.size || 0);
        const nextComment = joinComments(prevComment, incoming.comment);

        // 3) Update forms (id rule: use incoming _id if present, else "")
        const nextRecipeForm = {
          ...state.recipeForm,
          _id: incoming._id || "",
          recipeName: incoming.recipeName,
          recipe: name,
          size: nextSize,
          comment: nextComment,
        };

        const nextNewList = { ...state.newList, recipe: name };

        const { RefDbRecipe, customRecipe, customItem } = classifySelection(incoming);

        // 4) LocalStorage flag
        const vAlertMessages = {
          title: state.category === "999"
            ? i18n.t("recipe.UNSAVED_RECIPE_LEAVE_PAGE_TITLE")
            : i18n.t("recipe.UNSAVED_REGIMEN_LEAVE_PAGE_TITLE"),
          text: state.category === "999"
            ? i18n.t("recipe.UNSAVED_RECIPE_LEAVE_PAGE_TEXT_2")
            : i18n.t("recipe.UNSAVED_REGIMEN_LEAVE_PAGE_TEXT_2"),
        };
        localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
        IS_UNSAVED("yes");

        // 5) Write state (no other flags/toggles here; buttonsChecker handles UI)
        state = {
          ...state,
          replaceAlert: false,
          previousList: state.ingredientList,      // preserve previous list snapshot
          ingredientList: nextIngredientList,
          recipeForm: nextRecipeForm,
          newList: nextNewList,
          recipeNameBaseline: name,   // ← update baseline name confirmed Add
          recipeIdBaseline: incoming._id || "",// ← update baseline ID confirmed Add
          recipeHasIngredientBaseline: true,
          RefDbRecipe,
          customRecipe,
          customItem,
          // don't rebuild Base Display Area (duplicateList) here
        };

      } else if (action.status === "replace") {
        // 1) Replace list entirely
        nextIngredientList = [...normalizedConverted];

        // 2) Rebuild duplicateList from the new list
        nextDuplicateList = nextIngredientList.map((ing) => ({
          recipe_full: ing.recipe_full,
          size: ing.size || "0",
          unitid: ing.unitid,
        }));

        // 3) Update forms & snapshots
        const nextRecipeForm = {
          ...state.recipeForm,
          _id: incoming._id || "",
          recipeName: incoming.recipeName,
          recipe: name,
          size: incoming.size,
          comment: incoming.comment || "",
        };
        const nextRecipeFormValue = {
          recipe: name || incoming.name,
          size: incoming.size,
          comment: incoming.comment || "",
        };
        const nextNewList = { ...state.newList, recipe: name };
        
        const { RefDbRecipe, customRecipe, customItem } = classifySelection(incoming);

        // 4) Resets (per spec)
        state = {
          ...state,
          replaceAlert: false,
          itemChanged: false,
          firstChange: false,
          ingredientsAdded: false,
          duplicateList: nextDuplicateList,
          ingredientList: nextIngredientList,
          recipeForm: nextRecipeForm,
          recipeFormValue: nextRecipeFormValue,
          newList: nextNewList,
          ingredientForm: {},
          amountReseter: false,
          hhmmMode: false,
          ingredientSelected: {},
          amounNewValue: "",
          selectedIndex: -1,
          measurementOptions: [],
          cancelMode: false,
          replaceItemsAdded: true,
          recipeNameBaseline: name,   // ← update baseline name confirmed Replace
          recipeIdBaseline: incoming._id || "",// ← update baseline ID confirmed Replace
          recipeHasIngredientBaseline: true,
          RefDbRecipe,
          customRecipe,
          customItem,
        }

      } else if (action.status === "cancel") {
        // Close prompt and restore the name to what it was BEFORE the prompt opened.
        const fallbackName = state.recipeNameBaseline || (state.recipeForm && state.recipeForm.recipe) || "";

        const fallbackID =
          (typeof state.recipeIdBaseline === "string" ? state.recipeIdBaseline : "") ||
          (state.recipeForm && state.recipeForm._id) ||
          "";

        // Determine flags from baseline id + whether a list is currently present
        const baselineHasIngredient = !!state.recipeHasIngredientBaseline; // ← use baseline, not current list

        // Build a minimal record for classifySelection (it only cares about _id and list presence)
        const recForClass = baselineHasIngredient
          ? { _id: fallbackID, ingredients: [{}] } // "has list"
          : { _id: fallbackID };                   // "no list"

        const { RefDbRecipe, customRecipe, customItem } = classifySelection(recForClass);

        state = {
          ...state,
          replaceAlert: false,
          recipeForm: {
            ...state.recipeForm,
            recipe: fallbackName,
            _id: fallbackID
          },
          RefDbRecipe,
          customRecipe,
          customItem,
        };
      }

      // Single source of truth for UI toggles:
      // (You prefer free `state` inside buttonsChecker; leaving as-is.)
      buttonsChecker();

      return { ...state };
    }

    case getStarted(RECIPE_BARCODE_READ):
      state.partialResult = [];
      state.itemInVerAutofill = false;
      buttonsChecker();
      return {
        ...state,
        isLoading: true,
        upc404: false,
        barcodeCategoryRef: false,
        incorrectBarcodeCategory: false,
        itemInVerAutofill: false,
        barcodeRead: false,
        amountReseter: !state.amountReseter,
      };
    case getSucceeded(RECIPE_BARCODE_READ): {
      state.amountReseter = !state.amountReseter;
      state.measurementOptions = [];
      let cat =
        state.recipeForm.category == "999" ? "02" : state.recipeForm.category;
        
      const updateIngredientForm = (data) => {
        // normalize units -> always an array of strings
        const toArr = (u) => (Array.isArray(u) ? u : (u ? [u] : []));
        let item_units = toArr(data.units || data.unit);   // may be ["135"] or []

        state.ingredientForm = {
          ...state.ingredientForm,
          name: !data.name ? data.title : data.name,
          recipe_full: data.recipe_full || data.fullname,
          recipes: data.recipes,
          recipe: data.recipe,
          full_name: data.title,
          upc: !is_ref && upc,
          _id: data._id,
          is_history,
          is_own,
          is_ref,
          number_of_contribute,
        };
        
        // Prefer explicit unitid; else pick single non-910; else none
        if (data.unitid) {
          state.ingredientForm.unitid = String(data.unitid);
        } else if (item_units.length === 1 && String(item_units[0]) !== "910") {
          state.ingredientForm.unitid = String(item_units[0]);
        } else {
          state.ingredientForm.unitid = state.ingredientForm.unitid || "";
        }

        // keep all unit flavours in sync for downstream reducers
        state.ingredientForm.units    = item_units;
        state.ingredientForm.unit     = item_units;   // some paths read .unit
        state.ingredientForm.unitList = item_units;   // some paths read .unitList

        // Build dropdown options. If the item has no units ([]) → use full category units.
        const unitOptions = handleUnitDropdown(state.recipeForm.category, {
          ...data,
          units: item_units,
          unit: item_units,
          unitid: state.ingredientForm.unitid,
        });

        // Fallback: when unitOptions is empty or not an array and item_units is [], load the category's full unit list
        const categoryUnits = getCategoryUnits(state.recipeForm.category); // helper shown below
        state.measurementOptions =
          Array.isArray(unitOptions) && unitOptions.length
            ? unitOptions
            : (item_units.length === 0 ? categoryUnits : []);

        // No auto-select when “all units” applies — let user choose
        if (item_units.length === 0) {
          state.ingredientForm.unitid = "";
        }
      };
      state.amounNewValue = "";
      state.kitData = [];
      state.barcodeScanned = true;

      const {
        category,
        is_ref,
        is_own,
        is_history,
        upc,
        number_of_contribute,
        show_prompt,
      } = action.data;


      // -------- Non-RefDB ITEM --------
      if (!is_ref) {
        // -------- Item in Verification/Incorrect Category/Incompatible Category --------
        if (show_prompt && number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && category !== cat) {
              // own → incorrect category first
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true;
              
              state.showVerificationPrompt = true; // flag to trigger Item in Verification upon positive action
            } else {
              state.itemInVerAutofill = true;
              state.itemData = action.data;
            }
          }

          // -------- history = true --------
          else {
            if (category !== cat) {
              // mismatch → incompatible category ONLY
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;              
            } else {
              state.itemInVerAutofill = true;    
              state.itemData = action.data;        
            }
          }
        }

        // -------- Incorrect Category/Incompatible Category --------
        else if (number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && category !== cat) {
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true
            } else {
              updateIngredientForm(action.data);
            }
          }

          // -------- history = true --------
          else {
            if (category !== cat) {
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;
            } else {
              updateIngredientForm(action.data);
            }
          }
        }

        // -------- Product not in 12u12 DB/Incorrect Category/Incompatible Category --------
        else if (number_of_contribute < 4) {
          // -------- history = false --------
          if (!is_history) {
            if (!is_own) {
              state.contributeRedirectionAlert = true;
              state.upc404 = true;
              let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
                returnObjects: true,
              });
              state.listings = Object.entries(listingObject).map(([key, value]) => ({
                key,
                value,
              }));
              state.upc404Value = action.data.upc;
            } else if (category !== cat) {
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true
            } else {
              updateIngredientForm(action.data);
            }
          }

          // -------- history = true --------
          else {
            if (category !== cat) {
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;
            } else {
              updateIngredientForm(action.data);
            }
          }
        }
      } 
      
      // -------- RefDB ITEM --------
      else {
        if (category !== cat) {
          state.barcodeCategoryRef = true;
          state.refdb_item = true;
          const categories = i18n.t("CATEGORIES", { returnObjects: true });
          let categoryItem = categories.find((item) => item.value === category);
          state.refdb_item_category = categoryItem ? categoryItem.label : "";
          state.itemData = action.data;
        } else {
          action.data.upc = "";
          updateIngredientForm(action.data);
          state.barcodeRead = true;
        }
      }




      // if (
      //   number_of_contribute >= 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   show_prompt
      // ) {
      //   state.itemInVerAutofill = true;
      //   state.itemData = action.data;
      // } else if (
      //   action.data.category === cat &&
      //   number_of_contribute >= 4 &&
      //   !is_ref &&
      //   (!is_own || is_own) &&
      //   (!is_history || is_history) &&
      //   show_prompt
      // ) {
      //   state.itemInVerAutofill = true;
      //   state.itemData = action.data;
      // } else if (
      //   number_of_contribute < 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   !show_prompt
      // ) {
      //   state.contributeRedirectionAlert = true;
      //   state.upc404 = true;
      //   let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
      //     returnObjects: true,
      //   });
      //   state.listings = Object.entries(listingObject).map(([key, value]) => ({
      //     key,
      //     value,
      //   }));
      //   state.upc404Value = action.data.upc;
      // } else if (
      //   number_of_contribute >= 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   !show_prompt
      // ) {
      //   updateIngredientForm(action.data);
      // } else if (action.data.category === cat) {
      //   if (is_ref) {
      //     action.data.upc = "";
      //     updateIngredientForm(action.data);
      //     state.barcodeRead = true;
      //   } else if (is_own && !show_prompt) {
      //     updateIngredientForm(action.data);
      //   } else if (!is_ref && is_history && !show_prompt) {
      //     updateIngredientForm(action.data);
      //   } else if (number_of_contribute >= 4 && show_prompt) {
      //     state.itemInVerAutofill = true;
      //     state.itemData = action.data;
      //   }
      // } else {
      //   if (is_ref) {
      //     state.barcodeCategoryRef = true;
      //     state.refdb_item = true;
      //     const categories = i18n.t("CATEGORIES", { returnObjects: true });
      //     let categoryItem = categories.find(
      //       (item) => item.value === action.data.category
      //     );
      //     state.refdb_item_category = categoryItem ? categoryItem.label : "";
      //     state.itemData = action.data;
      //   } else if (is_history) {
      //     state.barcodeCategoryRef = true;
      //     state.refdb_item = false;
      //     const categories = i18n.t("CATEGORIES", { returnObjects: true });
      //     let categoryItem = categories.find(
      //       (item) => item.value === action.data.category
      //     );
      //     state.refdb_item_category = categoryItem ? categoryItem.label : "";
      //     state.itemData = action.data;
      //     state.itemData.setRef = true;
      //   } else if (is_own) {
      //     state.incorrectBarcodeCategory = true;
      //     state.itemData = action.data;
      //     state.itemData.setRef = true;
      //   }
      // }
      buttonsChecker();
      return {
        ...state,
        isLoading: false,
        barcodeRead: true,
      };
    }
    case getEnded(RECIPE_BARCODE_READ):
      savedData(state.disabled.saveBtn, state.recipeForm.category);
      return {
        ...state,
        isLoading: false,
        barcodeRead: true,
      };
    case getFailed(RECIPE_BARCODE_READ):
      state.upc404Value = action.upc;
      state.category404Value = action.val;
      state.contributeRedirectionAlert = true;
      let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
        returnObjects: true,
      });
      state.listings = Object.entries(listingObject).map(([key, value]) => ({
        key,
        value,
      }));
      buttonsChecker();
      savedData(state.disabled.saveBtn, state.recipeForm.category);
      return { ...state, isLoading: false, upc404: true };
    case getStarted(RECIPE_BARCODE_READ_IMG):
      state.itemInVerAutofill = false;
      return { ...state, barcodeFailed: false, isLoading: true };
    case getSucceeded(RECIPE_BARCODE_READ_IMG):
      return { ...state, isLoading: false };
    case getFailed(RECIPE_BARCODE_READ_IMG):
      return { ...state, barcodeFailed: true, isLoading: false };
    case getSucceeded(PARTIAL_RESULT_FOUND):
      let getResult = action.partialSearch;
      savedData(state.disabled.saveBtn, state.recipeForm.category);
      return {
        ...state,
        partialResult: getResult,
      };
    case getFailed(PARTIAL_RESULT_FOUND):
      savedData(state.disabled.saveBtn, state.recipeForm.category);
      return {
        ...state,
        barcodeValue: action.upc,
        addCustomAlert: true,
      };
    case ON_CHANGE_ALERT_STATUS:
      state.addCustomAlert = !!action.data.addCustomAlert;
      return {
        ...state,
        ...action.data,
      };
    case RESET_CONTRIBUTE_ALERT_STATE:
      state.contributeRedirectionAlert = false;
      state.upc404 = false;
      return { ...state };
    case SET_HHMM_MODE:
      state.hhmmMode = action.value;
      return {
        ...state,
      };
    case ADD_GREY_UPC_ITEM_NAME_FIELD:
      state.ingredientForm = {
        ...state.ingredientForm,
        upc: action.payload,
      };
      state.disabled.scale = true;
      state.disabled.size = true;
      return { ...state };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/recipeReducer.js